import { ErrorBoundary } from '@/components/ErrorBoundary';

import AppRouter from './router';
import { SecurityProvider } from './contexts/security';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <SecurityProvider>
        <AppRouter />
      </SecurityProvider>
    </ErrorBoundary>
  );
}

export default App;
